export const solutionsData = [
    {
        link: '/solutions/quoting',
        title: 'Go to Quoting page',
        name: 'Quoting',
        key: 'INSURANCE_SOLUTION_QUOTING',
    },
    {
        link: '/solutions/transformation-delivery',
        title: 'Go to Policy Administration page',
        name: 'Policy Administration',
        key: 'INSURANCE_SOLUTION_POLICY_ADMINISTRATION',
    },
    {
        link: '/solutions/claims-handling',
        title: 'Go to Claims Handling page',
        name: 'Claims Handling',
        key: 'INSURANCE_SOLUTION_CLAIMS_HANDLING',
    },
    {
        link: '/solutions/accounting-and-payments',
        title: 'Go to Accounting & Payments page',
        name: 'Accounting & Payments',
        key: 'INSURANCE_SOLUTION_ACCOUNTING_AND_PAYMENTS',
    },
    {
        link: '/solutions/reinsurance',
        title: 'Go to Reinsurance page',
        name: 'Reinsurance',
        key: 'INSURANCE_SOLUTION_REINSURANCE',
    },
    {
        link: '/solutions/digital-customer-journey',
        title: 'Go to Digital Customer Journey page',
        name: 'Digital Customer Journey',
        key: 'INSURANCE_SOLUTION_DIGITAL_CUSTOMER_JOURNEY',
    },
    {
        link: '/solutions/data-management-and-insight',
        title: 'Go to ata Management & Insight page',
        name: 'Data Management & Insight',
        key: 'INSURANCE_SOLUTION_DATA_MANAGEMENT_AND_INSIGHT',
    },
];
